import OSNotification from 'onesignal-cordova-plugin/dist/OSNotification';
import { useOneSignal } from '../../hooks/OneSignalHooks';
import { useNotifsByUser } from '../../hooks/WPHooks';
import { useLogger } from '../../services/LogService';

export const PushNotification = () => {
  const { fetchNotifs } = useNotifsByUser();

  const logger = useLogger('PushNotification');

  const openNotif = (notif: OSNotification) => {
    const data = notif.additionalData;
    logger.info('openNotif()', data);
  };

  useOneSignal({ refreshNotifs: fetchNotifs, openNotif: openNotif });

  return <></>;
};
